import { Button, useRefresh, useNotify, useRecordContext } from "react-admin";
import { AcademicSessionTypes } from "utils/constants";
import { IconButton, Typography } from "@mui/material";
import { studentRequests } from "api/studentApi";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";

const FinalizeButton = ({ isMobile }) => {
  const record = useRecordContext();
  const refresh = useRefresh();
  const notify = useNotify();

  if (record.type === AcademicSessionTypes.SummerSemester || record.type === AcademicSessionTypes.WinterSemester) {
    return null;
  }

  const handleFinalize = async () => {
    await dataProvider.customRequest(studentRequests.finalizeAcademicSession(record.id), null, "POST");
    refresh();
    notify("Успешно финализиране на академична сесия (за изпити)", { type: "success" });
  };

  if (record.isFinalized) {
    return (
      <Typography
        sx={{
          color: theme => theme.palette.success.main,
          fontWeight: "bold",
        }}
      >
        Финализирана
      </Typography>
    );
  }

  return (
    <ConfirmModal
      onConfirm={handleFinalize}
      titleContent={"Финализиране на сесия"}
      triggerButton={
        isMobile ? (
          <IconButton
            size="small"
            color="primary"
            aria-label="Финализирай"
          >
            <ThumbUpAltIcon fontSize="small" />
          </IconButton>
        ) : (
          <Button
            label="Финализирай"
            startIcon={<ThumbUpAltIcon />}
          />
        )
      }
      message={`Сигурни ли сте, че искате да финализирате ${record?.typeText} за ${record?.academicYearName}?`}
    />
  );
};

export default FinalizeButton;
